// src/services/batteryEstimator.service.js
import axios from "axios";
import { authService } from "./auth.service";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5172/api";
export const batteryEstimatorService = {
  // 1️⃣ Calculate Battery Cost
  estimateBattery: async (batteryData) => {
    const token = await authService.getToken();
    if (!token) throw new Error("Authentication token missing.");

    const response = await axios.post(
      `${API_URL}/battery/estimate`,
      batteryData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  },

  // 2️⃣ ⭐️ NEW: Send Inquiry Email
  sendInquiry: async (inquiryData) => {
    const token = await authService.getToken();

    // Optional: If you want to allow guests to inquire, remove this check.
    // But since you said "user need to login", we keep it.
    if (!token) throw new Error("Authentication token missing. Please log in.");

    const response = await axios.post(
      `${API_URL}/battery/send-inquiry`,
      inquiryData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  },
};
